import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import ProtectedLayout from './layouts/ProtectedLayout'
import Login from './pages/Login'
import Comenzi from './pages/Comenzi'
import Clienti from './pages/Clienti'
import Furnizori from './pages/Furnizori'
import Produse from './pages/Produse'
import ClientDetails from './pages/ClientsDetails'
import OrderDetails from './pages/orderDetails'
import DeComandat from './pages/DeComandat'
import './App.css'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route element={<ProtectedLayout />}>
          <Route path="/" element={<Navigate to="/comenzi" replace />} />
          <Route path="/comenzi" element={<Comenzi />} />
          <Route path="/clienti" element={<Clienti />} />
          <Route path="/clienti/:clientSlug" element={<ClientDetails />} />
          <Route path="/clienti/:clientSlug/:orderUuid" element={<OrderDetails />} />
          <Route path="/furnizori" element={<Furnizori />} />
          <Route path="/produse" element={<Produse />} />
          <Route path="/comanda-furnizor" element={<DeComandat />} />
        </Route>

        <Route path="*" element={<Navigate to="/comenzi" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App